/**
 * Node.js module for Forge.
 *
 * @author Dave Longley
 *
 * Copyright 2011-2016 Digital Bazaar, Inc.
 */
module.exports = {
  // default options
  options: {
    usePureJavaScript: false
  }
};



//////////////////
// WEBPACK FOOTER
// ./~/node-forge/lib/forge.js
// module id = 10
// module chunks = 25